import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {ManufacturerCollection} from './manufacturer-collection';
import * as classTransformer from 'class-transformer';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {Manufacturer} from './manufacturer';

@Injectable({
  providedIn: 'root',
})
export class ManufacturerService {
    constructor(
        private httpClient: HttpClient,
    ) {
    }

    static buildIri(manufacturer: Manufacturer): string {
        return `/cpe/manufacturers/${manufacturer.id}`;
    }

    public getAll(): Observable<ManufacturerCollection> {
        return this.httpClient
            .get('/manufacturers')
            .pipe(map((result: any) => {
                const collection = new ManufacturerCollection();
                collection.setTotalItems(result['totalItems']);
                collection.setManufacturers(
                    result['member'].map((manufacturerData: any) => classTransformer.plainToInstance(Manufacturer, manufacturerData))
                );

                return collection;
            }));
    }
}
